var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-cascader',{attrs:{"options":_vm.options,"props":{value:'id',label:'deptName'},"change-on-select":_vm.changeOnSelect,"show-all-levels":false,"clearable":""},model:{value:(_vm.deptIds),callback:function ($$v) {_vm.deptIds=$$v},expression:"deptIds"}})
}
var staticRenderFns = []

export { render, staticRenderFns }